// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: XLdxTqqsags

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicArticleItem.module.css"; // plasmic-import: XLdxTqqsags/css

createPlasmicElementProxy;

export type PlasmicArticleItem__VariantMembers = {
  composition: "full" | "hideImage" | "hideSnippet" | "titleOnly";
};
export type PlasmicArticleItem__VariantsArgs = {
  composition?: MultiChoiceArg<
    "full" | "hideImage" | "hideSnippet" | "titleOnly"
  >;
};
type VariantPropType = keyof PlasmicArticleItem__VariantsArgs;
export const PlasmicArticleItem__VariantProps = new Array<VariantPropType>(
  "composition"
);

export type PlasmicArticleItem__ArgsType = {
  snippet?: React.ReactNode;
  source?: React.ReactNode;
  readingTime?: React.ReactNode;
  date?: React.ReactNode;
  title?: React.ReactNode;
  articleImage?: React.ReactNode;
};
type ArgPropType = keyof PlasmicArticleItem__ArgsType;
export const PlasmicArticleItem__ArgProps = new Array<ArgPropType>(
  "snippet",
  "source",
  "readingTime",
  "date",
  "title",
  "articleImage"
);

export type PlasmicArticleItem__OverridesType = {
  root?: p.Flex<"div">;
  articleContent?: p.Flex<"div">;
  titleContainer?: p.Flex<"div">;
  metadataContainer?: p.Flex<"div">;
  sourceContainer?: p.Flex<"div">;
  metadata?: p.Flex<"div">;
  readingTimeContainer?: p.Flex<"div">;
  dateContainer?: p.Flex<"div">;
  snippetContainer?: p.Flex<"div">;
  titleImage?: p.Flex<"div">;
  image?: p.Flex<typeof p.PlasmicImg>;
  imageContainer?: p.Flex<"div">;
};

export interface DefaultArticleItemProps {
  snippet?: React.ReactNode;
  source?: React.ReactNode;
  readingTime?: React.ReactNode;
  date?: React.ReactNode;
  title?: React.ReactNode;
  articleImage?: React.ReactNode;
  composition?: MultiChoiceArg<
    "full" | "hideImage" | "hideSnippet" | "titleOnly"
  >;
  className?: string;
}

const $$ = {};

function PlasmicArticleItem__RenderFunc(props: {
  variants: PlasmicArticleItem__VariantsArgs;
  args: PlasmicArticleItem__ArgsType;
  overrides: PlasmicArticleItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "composition",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.composition
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootcomposition_full]: hasVariant($state, "composition", "full"),
          [sty.rootglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          )
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"articleContent"}
        data-plasmic-override={overrides.articleContent}
        hasGap={true}
        className={classNames(projectcss.all, sty.articleContent, {
          [sty.articleContentcomposition_full]: hasVariant(
            $state,
            "composition",
            "full"
          ),
          [sty.articleContentcomposition_hideImage]: hasVariant(
            $state,
            "composition",
            "hideImage"
          ),
          [sty.articleContentcomposition_hideSnippet]: hasVariant(
            $state,
            "composition",
            "hideSnippet"
          ),
          [sty.articleContentcomposition_titleOnly]: hasVariant(
            $state,
            "composition",
            "titleOnly"
          ),
          [sty.articleContentglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          )
        })}
      >
        <p.Stack
          as={"div"}
          hasGap={true}
          className={classNames(projectcss.all, sty.freeBox__nKzNe, {
            [sty.freeBoxcomposition_full__nKzNeGpQ8Y]: hasVariant(
              $state,
              "composition",
              "full"
            ),
            [sty.freeBoxcomposition_titleOnly__nKzNeYnz76]: hasVariant(
              $state,
              "composition",
              "titleOnly"
            ),
            [sty.freeBoxglobal_theme_dark__nKzNeOIz4X]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__vnck5, {
              [sty.freeBoxcomposition_full__vnck5GpQ8Y]: hasVariant(
                $state,
                "composition",
                "full"
              ),
              [sty.freeBoxcomposition_hideSnippet__vnck5TAz0Z]: hasVariant(
                $state,
                "composition",
                "hideSnippet"
              ),
              [sty.freeBoxcomposition_titleOnly__vnck5Ynz76]: hasVariant(
                $state,
                "composition",
                "titleOnly"
              ),
              [sty.freeBoxglobal_theme_dark__vnck5OIz4X]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            <div
              data-plasmic-name={"titleContainer"}
              data-plasmic-override={overrides.titleContainer}
              className={classNames(projectcss.all, sty.titleContainer, {
                [sty.titleContainercomposition_full]: hasVariant(
                  $state,
                  "composition",
                  "full"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: "There seems to be no title for this article",
                value: args.title,
                className: classNames(sty.slotTargetTitle, {
                  [sty.slotTargetTitlecomposition_full]: hasVariant(
                    $state,
                    "composition",
                    "full"
                  ),
                  [sty.slotTargetTitleglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })
              })}
            </div>
          </div>
          <div
            data-plasmic-name={"metadataContainer"}
            data-plasmic-override={overrides.metadataContainer}
            className={classNames(projectcss.all, sty.metadataContainer, {
              [sty.metadataContainercomposition_hideSnippet]: hasVariant(
                $state,
                "composition",
                "hideSnippet"
              ),
              [sty.metadataContainercomposition_titleOnly]: hasVariant(
                $state,
                "composition",
                "titleOnly"
              ),
              [sty.metadataContainerglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            <div
              data-plasmic-name={"sourceContainer"}
              data-plasmic-override={overrides.sourceContainer}
              className={classNames(projectcss.all, sty.sourceContainer, {
                [sty.sourceContainerglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__bWxh4
                    )}
                  >
                    {"The Verge"}
                  </div>
                ),
                value: args.source,
                className: classNames(sty.slotTargetSource, {
                  [sty.slotTargetSourceglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })
              })}
            </div>
            <p.Stack
              as={"div"}
              data-plasmic-name={"metadata"}
              data-plasmic-override={overrides.metadata}
              hasGap={true}
              className={classNames(projectcss.all, sty.metadata, {
                [sty.metadataglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              <div
                data-plasmic-name={"readingTimeContainer"}
                data-plasmic-override={overrides.readingTimeContainer}
                className={classNames(
                  projectcss.all,
                  sty.readingTimeContainer,
                  {
                    [sty.readingTimeContainercomposition_full]: hasVariant(
                      $state,
                      "composition",
                      "full"
                    )
                  }
                )}
              >
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__i2O9
                      )}
                    >
                      {"2 min read"}
                    </div>
                  ),
                  value: args.readingTime,
                  className: classNames(sty.slotTargetReadingTime, {
                    [sty.slotTargetReadingTimecomposition_hideSnippet]:
                      hasVariant($state, "composition", "hideSnippet"),
                    [sty.slotTargetReadingTimeglobal_theme_dark]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    )
                  })
                })}
              </div>
              <div
                data-plasmic-name={"dateContainer"}
                data-plasmic-override={overrides.dateContainer}
                className={classNames(projectcss.all, sty.dateContainer)}
              >
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__vzBiB
                      )}
                    >
                      {"1 months ago"}
                    </div>
                  ),
                  value: args.date,
                  className: classNames(sty.slotTargetDate, {
                    [sty.slotTargetDatecomposition_hideSnippet]: hasVariant(
                      $state,
                      "composition",
                      "hideSnippet"
                    ),
                    [sty.slotTargetDateglobal_theme_dark]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    )
                  })
                })}
              </div>
            </p.Stack>
          </div>
          {(
            hasVariant($state, "composition", "titleOnly")
              ? false
              : hasVariant($state, "composition", "hideSnippet")
              ? false
              : true
          ) ? (
            <div
              data-plasmic-name={"snippetContainer"}
              data-plasmic-override={overrides.snippetContainer}
              className={classNames(projectcss.all, sty.snippetContainer, {
                [sty.snippetContainercomposition_hideSnippet]: hasVariant(
                  $state,
                  "composition",
                  "hideSnippet"
                ),
                [sty.snippetContainercomposition_titleOnly]: hasVariant(
                  $state,
                  "composition",
                  "titleOnly"
                ),
                [sty.snippetContainerglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__qxWGx
                    )}
                  >
                    {
                      "Your goal in life is to find out the people who need you the most, to finda out the business that needs you the most, to find the project and the art that needs you the most. There is something out there just for you..."
                    }
                  </div>
                ),
                value: args.snippet,
                className: classNames(sty.slotTargetSnippet, {
                  [sty.slotTargetSnippetcomposition_hideImage]: hasVariant(
                    $state,
                    "composition",
                    "hideImage"
                  ),
                  [sty.slotTargetSnippetcomposition_hideSnippet]: hasVariant(
                    $state,
                    "composition",
                    "hideSnippet"
                  ),
                  [sty.slotTargetSnippetcomposition_titleOnly]: hasVariant(
                    $state,
                    "composition",
                    "titleOnly"
                  ),
                  [sty.slotTargetSnippetglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.slotTargetSnippetglobal_theme_light]: hasVariant(
                    globalVariants,
                    "theme",
                    "light"
                  )
                })
              })}
            </div>
          ) : null}
        </p.Stack>
        {(
          hasVariant($state, "composition", "titleOnly")
            ? false
            : hasVariant($state, "composition", "hideImage")
            ? false
            : false
        ) ? (
          <div
            data-plasmic-name={"titleImage"}
            data-plasmic-override={overrides.titleImage}
            className={classNames(projectcss.all, sty.titleImage, {
              [sty.titleImagecomposition_full]: hasVariant(
                $state,
                "composition",
                "full"
              ),
              [sty.titleImagecomposition_hideImage]: hasVariant(
                $state,
                "composition",
                "hideImage"
              ),
              [sty.titleImagecomposition_hideSnippet]: hasVariant(
                $state,
                "composition",
                "hideSnippet"
              ),
              [sty.titleImagecomposition_titleOnly]: hasVariant(
                $state,
                "composition",
                "titleOnly"
              ),
              [sty.titleImageglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            <p.PlasmicImg
              data-plasmic-name={"image"}
              data-plasmic-override={overrides.image}
              alt={""}
              className={classNames(sty.image, {
                [sty.imagecomposition_full]: hasVariant(
                  $state,
                  "composition",
                  "full"
                ),
                [sty.imagecomposition_hideSnippet]: hasVariant(
                  $state,
                  "composition",
                  "hideSnippet"
                ),
                [sty.imageglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"none"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"100%"}
              loader={"plasmic"}
              src={{
                src: "https://img.plasmic.app/img-optimizer/v1/img/e5ba804d02d58bafd284fe3e78e1f10e.jpg",
                fullWidth: 708,
                fullHeight: 472
              }}
            />
          </div>
        ) : null}
        <div
          data-plasmic-name={"imageContainer"}
          data-plasmic-override={overrides.imageContainer}
          className={classNames(projectcss.all, sty.imageContainer, {
            [sty.imageContainerglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            )
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents: null,
            value: args.articleImage
          })}
        </div>
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "articleContent",
    "titleContainer",
    "metadataContainer",
    "sourceContainer",
    "metadata",
    "readingTimeContainer",
    "dateContainer",
    "snippetContainer",
    "titleImage",
    "image",
    "imageContainer"
  ],
  articleContent: [
    "articleContent",
    "titleContainer",
    "metadataContainer",
    "sourceContainer",
    "metadata",
    "readingTimeContainer",
    "dateContainer",
    "snippetContainer",
    "titleImage",
    "image",
    "imageContainer"
  ],
  titleContainer: ["titleContainer"],
  metadataContainer: [
    "metadataContainer",
    "sourceContainer",
    "metadata",
    "readingTimeContainer",
    "dateContainer"
  ],
  sourceContainer: ["sourceContainer"],
  metadata: ["metadata", "readingTimeContainer", "dateContainer"],
  readingTimeContainer: ["readingTimeContainer"],
  dateContainer: ["dateContainer"],
  snippetContainer: ["snippetContainer"],
  titleImage: ["titleImage", "image"],
  image: ["image"],
  imageContainer: ["imageContainer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  articleContent: "div";
  titleContainer: "div";
  metadataContainer: "div";
  sourceContainer: "div";
  metadata: "div";
  readingTimeContainer: "div";
  dateContainer: "div";
  snippetContainer: "div";
  titleImage: "div";
  image: typeof p.PlasmicImg;
  imageContainer: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicArticleItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicArticleItem__VariantsArgs;
    args?: PlasmicArticleItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicArticleItem__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicArticleItem__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicArticleItem__ArgProps,
          internalVariantPropNames: PlasmicArticleItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicArticleItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicArticleItem";
  } else {
    func.displayName = `PlasmicArticleItem.${nodeName}`;
  }
  return func;
}

export const PlasmicArticleItem = Object.assign(
  // Top-level PlasmicArticleItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    articleContent: makeNodeComponent("articleContent"),
    titleContainer: makeNodeComponent("titleContainer"),
    metadataContainer: makeNodeComponent("metadataContainer"),
    sourceContainer: makeNodeComponent("sourceContainer"),
    metadata: makeNodeComponent("metadata"),
    readingTimeContainer: makeNodeComponent("readingTimeContainer"),
    dateContainer: makeNodeComponent("dateContainer"),
    snippetContainer: makeNodeComponent("snippetContainer"),
    titleImage: makeNodeComponent("titleImage"),
    image: makeNodeComponent("image"),
    imageContainer: makeNodeComponent("imageContainer"),

    // Metadata about props expected for PlasmicArticleItem
    internalVariantProps: PlasmicArticleItem__VariantProps,
    internalArgProps: PlasmicArticleItem__ArgProps
  }
);

export default PlasmicArticleItem;
/* prettier-ignore-end */
